module.exports = __webpack_public_path__ + "img/skateboard.d1a91510.png";